(() => {
  document.querySelectorAll('[data-wk-gallery]').forEach(gallery => {
    if (gallery.dataset.enhanced) return;
    const track = gallery.querySelector('[data-gallery-track]');
    const slides = [...track.querySelectorAll('[data-gallery-slide]')];
    const buttons = [...gallery.querySelectorAll('[data-gallery-go]')];
    const nav = gallery.querySelector('[data-gallery-nav]');
    if (!slides.length || slides.length !== buttons.length) return;
    const update = () => {
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
      buttons.forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      slides.forEach((slide, i) => { if (i !== index) slide.querySelectorAll('video').forEach(video => video.pause()); });
    };
    const go = index => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, index)) * track.clientWidth, behavior: 'instant'});
    buttons.forEach((button, index) => button.addEventListener('click', () => go(index)));
    track.addEventListener('scroll', update, {passive: true});
    track.addEventListener('keydown', event => {
      const current = Math.round(track.scrollLeft / track.clientWidth);
      const target = {ArrowRight: current + 1, ArrowLeft: current - 1, Home: 0, End: slides.length - 1}[event.key];
      if (target !== undefined) {event.preventDefault(); go(target);}
    });
    window.addEventListener('resize', update, {passive: true});
    gallery.dataset.enhanced = 'true';
    nav.hidden = false;
    update();
  });
})();
